import { Card } from "@acme/ui/card";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import useClanDetailAccess from "~/features/clan-detail/_hooks/useClanDetailAccess.js";
import useClanFeatureAccess from "~/features/clan-permissions/_hooks/useClanFeatureAccess.js";

export const Route = createFileRoute("/_authed/my-clans/$tag/social-media")({
  component: SocialMediaTab,
});

function SocialMediaTab() {
  const { t } = useTranslation();
  const { tag } = Route.useParams();
  const { isReady, effectivePermissions } = useClanDetailAccess({ tag });
  const { canRead, canWrite } = useClanFeatureAccess({ domain: "socialMedia", permissions: effectivePermissions });

  if (!isReady || !canRead) return null;

  return (
    <Card className="p-6">
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">{t("app.placeholders.clanSocialMediaTitle")}</h2>
        <p className="text-sm text-muted-foreground">{t("app.placeholders.clanSocialMediaDescription")}</p>
        {!canWrite && (
          <p className="text-sm text-muted-foreground">{t("app.clanPermissions.readOnlyHint")}</p>
        )}
      </div>
    </Card>
  );
}
